import { Country, EnumSchema, OptionalString } from '@40seas/entities/common';
import auStates from 'libs/shared/address/src/lib/statesProvider/auStates';
import caStates from 'libs/shared/address/src/lib/statesProvider/caStates';
import { abbr } from 'us-state-converter';
import { z } from 'zod';

const countriesWithStates = [Country.UNITED_STATES, Country.CANADA, Country.AUSTRALIA];

export const BankAccountAddressSchema = z
    .object({
        country: EnumSchema(Country).refine((country) => country, {
            message: 'Country is required',
            path: ['country'],
        }),
        state: OptionalString(z.string()),
        city: z.string().min(1),
        addressLine1: z.string().min(1),
        zipCode: OptionalString(z.string().min(1).max(35)),
        addressLine2: z.any(),
    })
    .strict()
    .refine(
        (data: any) => {
            if (countriesWithStates.includes(data.country) && data.state?.length > 2) {
                data.state =
                    Country.UNITED_STATES === data.country
                        ? abbr(data.state)
                        : Country.CANADA === data.country
                        ? caStates.find((province) => province.name === data.state)?.code || data.state
                        : auStates.find((province) => province.name === data.state)?.code || data.state;
            }
            if (!countriesWithStates.includes(data.country) && data.state) {
                delete data.state;
            }
            if (data.country === Country.HONG_KONG && data.zipCode) {
                delete data.zipCode;
            }
            if (data.addressLine2) {
                delete data.addressLine2;
            }
            return !!data.country;
        },
        {
            message: 'Country is required',
            path: ['country'],
        },
    )
    .refine(
        (data) =>
            ((data?.country === Country.AUSTRALIA || data?.state?.length === 2) && countriesWithStates.includes(data.country)) ||
            !countriesWithStates.includes(data.country),
        {
            message: 'State is required',
            path: ['state'],
        },
    )
    .refine(
        (data) =>
            (data.zipCode && data.zipCode.length <= 5 && data.country === Country.UNITED_STATES) || data.country !== Country.UNITED_STATES,
        {
            message: 'ZipCode is more than 5 characters',
            path: ['zipCode'],
        },
    )
    .refine((data) => (!!data.zipCode && data.country !== Country.HONG_KONG) || data.country === Country.HONG_KONG, {
        message: 'ZipCode is required',
        path: ['zipCode'],
    });
